module.exports = __webpack_public_path__ + "static/img/46.515fbe9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fifa2026/flag_icons/46.png
// module id = axpc
// module chunks = 1